import $ from "jquery";
import GameLogic from "@bd-core/game-logic";
import CONFIG from "@bd-core/config";
import Storage from "@bd-utils/storage";
import { getCurrentPageId } from "@bd-stores/user-progress";
import bdjs from "@bd-core/bdjs";
import { getIsRoomTimeOut } from "@bd-stores/game-progress";
import { generateQrCode } from "./qr-code";

export default class CompletionPopup {
    constructor() {
        this.elms = {
            popup: ".js-room-completion",
            closeBtn: ".js-completionPopup-close",
            goToMainRoom: ".js-completionPopup-goto",
        };

        this.shownIds = [];

        return this;
    }

    init() {
        const self = this;
        const elms = this.elms;
        const $popup = $(elms.popup);

        $popup.find(elms.closeBtn).on("click", this.hide.bind(this));
        $popup.find(elms.goToMainRoom).on("click", function () {
            const currentPageID = getCurrentPageId();

            self.hide();
            $(".timer").removeClass("is-clues-equation");

            const mainRoomID = CONFIG?.game?.rooms.find(
                (key) => key.id == currentPageID,
            ).mainroom_id;

            GameLogic.goToPage(mainRoomID);
        });

        return this;
    }

    _setHasSeen(roomId) {
        let states = Storage.get("states", {});
        if (!states?.completions) states.completions = [];
        states.completions.push(roomId);
        return Storage.set("states", states);
    }

    _getHasSeen(roomId) {
        let states = Storage.get("states", {});
        return states?.completions && states.completions.includes(roomId);
    }

    maybeResetState(roomId) {
        if (!this._getHasSeen(roomId)) return false;

        let states = Storage.get("states", {});
        if (!states?.completions) states.completions = [];

        const initialLength = states.completions.length;
        const completions = bdjs.removeItemArray(states.completions, roomId);

        //There is item removed, we need to update the Storage
        if (completions.length !== initialLength) {
            states.completions = completions;
            return Storage.set("states", states);
        }

        return false;
    }

    show(roomId, isMiddleState, roomAnswers) {
        const hasSeen = this.shownIds.includes(roomId); //this._getHasSeen(roomId);
        const currentPageId = getCurrentPageId();

        if (currentPageId !== roomId || hasSeen) return;

        const rooms = CONFIG?.game?.rooms || false;

        if (!Array.isArray(rooms) || !rooms.length) return;

        const room = rooms.find((r) => r?.id == roomId);
        if (!room) return;

        const isRoomTimeout = getIsRoomTimeOut(roomId);
        const isTeamconnectorRoom = room.type === "teamconnector_room";

        let $popup = $(this.elms.popup);
        let title, text;

        if (isRoomTimeout) {
            title = room?.room?.timeout_popup?.title || false;
            text = room?.room?.timeout_popup?.content || false;
            $popup.find(".msn-popup").removeClass("blue").addClass("magenta");
        } else {
            title = room?.room?.completion_popup?.title || false;
            text = room?.room?.completion_popup?.content || false;
            $popup.find(".msn-popup").removeClass("magenta").addClass("blue");
        }

        if (isMiddleState) {
            let middleStateCounter = 0;

            if (typeof roomAnswers == "object") {
                $.each(roomAnswers, (answerId, objAnswer) => {
                    if (objAnswer?.isMiddleState) middleStateCounter++;
                });
            }

            text = room?.room?.completion_popup?.middlecontent || "";
            text = text.replaceAll("{x}", `${middleStateCounter}`);
        }

        if (isTeamconnectorRoom) {
            $(this.elms.goToMainRoom).removeClass("is-mainroom");
        } else {
            $(this.elms.goToMainRoom).addClass("is-mainroom");
        }

        if (!title && !text) return;

        if ($popup.hasClass("is-open")) this.hide();

        $popup.addClass("is-with-close");
        $popup.find(".js-completion-popup-title").text(title);
        // @ts-ignore
        if (text) $popup.find(".js-completion-popup-text").html(text);

        // generate qr code for challenge 1
        if (room.room.room_type === "match_card") {
            let userRegion = CONFIG.game.region;
            userRegion =
                !userRegion || userRegion === "" ? "Global" : userRegion;
            const region = CONFIG.game.regions.find(
                (r) => r.region_name === userRegion,
            );
            if (region) {
                const pdfUrl = region.qr_code_pdf;
                if (pdfUrl) generateQrCode(pdfUrl);
                if (isRoomTimeout) $(".ch-qr-code").css({ display: "none" });
            }
        }

        $popup.addClass("is-open");

        // hide timer hint popup
        $('.js-popup-timerhint').removeClass("is-open");

        if (!hasSeen) this._setHasSeen(roomId);
        this.shownIds.push(roomId);
    }

    hide() {
        const $popup = $(this.elms.popup);
        $popup.removeClass("is-open");
    }
}
